import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, type VaultValue } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { EncryptedCell } from '@/components';
import hasDataIdentifier from '@/utils/has-data-identifier';
import Field from '../../../../../field';
export type CorporationTypeType = {
  di: DataIdentifier;
  entity: Entity;
};
const CorporationType = t0 => {
  const $ = _c(7);
  const {
    di,
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "vault.basic.corporationType"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("business-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = value => {
      if (value === "agent") {
        return t(_temp);
      }
      if (value === "c_corporation") {
        return t(_temp2);
      }
      if (value === "s_corporation") {
        return t(_temp3);
      }
      if (value === "b_corporation") {
        return t(_temp4);
      }
      if (value === "llc") {
        return t(_temp5);
      }
      if (value === "llp") {
        return t(_temp6);
      }
      if (value === "non_profit") {
        return t(_temp7);
      }
      if (value === "partnership") {
        return t(_temp8);
      }
      if (value === "sole_proprietorship") {
        return t(_temp9);
      }
      if (value === "trust") {
        return t(_temp10);
      }
      return t(_temp11);
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getCorporationTypeText = t2;
  let t3;
  if ($[3] !== di || $[4] !== entity || $[5] !== getCorporationTypeText) {
    t3 = hasDataIdentifier(entity, "business.corporation_type") ? <Field di={di} entity={entity} renderValue={value_0 => {
      if (isVaultDataDecrypted(value_0)) {
        return <div className="text-body-2 text-primary" data-dd-privacy="mask">{getCorporationTypeText(value_0)}</div>;
      }
      return <EncryptedCell />;
    }} /> : null;
    $[3] = di;
    $[4] = entity;
    $[5] = getCorporationTypeText;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default CorporationType;
function _temp($) {
  return $.agent;
}
function _temp2($_0) {
  return $_0.c_corporation;
}
function _temp3($_1) {
  return $_1.s_corporation;
}
function _temp4($_2) {
  return $_2.b_corporation;
}
function _temp5($_3) {
  return $_3.llc;
}
function _temp6($_4) {
  return $_4.llp;
}
function _temp7($_5) {
  return $_5.non_profit;
}
function _temp8($_6) {
  return $_6.partnership;
}
function _temp9($_7) {
  return $_7.sole_proprietorship;
}
function _temp10($_8) {
  return $_8.trust;
}
function _temp11($_9) {
  return $_9.unknown;
}